import React, { useEffect, useState } from "react";
import { Collapse, Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import styles from "./FAQs.module.css";
import { InputField, SubmitButton } from "../../components";
import HeadingComponent from "../../components/HeadingComponent/HeadingComponent";
import { useDispatch } from "react-redux";
import { PagesMiddleware } from "../../Store/Middlewares/PagesMiddleware";
import { showAlert } from "../../Store/Actions/GeneralActions";

const { Panel } = Collapse;

const FAQs = () => {

  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [faqList, setFaqList] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    getData()
  }, []);

  const getData = (arg) => {
    dispatch(PagesMiddleware.getFAQ())
      .then((res) => {
        setFaqList(res);
      })
      .catch((err) => { console.log("error", err) });
  }

  const handleSave = () => {
    if (!question.trim() || !answer.trim()) {
      dispatch(showAlert({ type: "warning", message: "Please fill all the fields" }));
      return
    }
    const newFaq = { question: question, answer: answer };
    dispatch(PagesMiddleware.createFAQ(newFaq))
      .then((res) => {
        setQuestion("");
        setAnswer("");
        setFaqList([res, ...faqList]);
      })
      .catch((err) => { console.log("error", err) });
  };

  const handleDelete = (id) => {
    dispatch(PagesMiddleware.deleteFAQ({ id: id }))
      .then((res) => {
        setFaqList(null)
        setFaqList(res)
      })
      .catch((err) => { console.log("error", err) });
  }

  return (
    <div className={styles.mainCon}>
      <div className={styles.AccountContent}>
        <HeadingComponent
          text={"Frequently Asked Questions"}
          fontSize={20}
          padding={"0px"}
        />

        <InputField
          label={"Question"}
          style={{ marginTop: "30px" }}
          placeholder={"Type your question here"}
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
        />

        <InputField
          textArea
          rows={9}
          label={"Answer"}
          style={{ marginTop: "10px" }}
          placeholder={"Type your answer here"}
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
        />

        <div className={styles.buttonRow}>
          <SubmitButton title={"Save"} onClick={handleSave} primary style={{ width: '100%' }} />
        </div>

        {faqList?.length > 0 && (
          <div className={styles.listContainer}>
            <Collapse accordion className={styles.accordion}>
              {faqList.map((faq) => (
                <Panel
                  header={
                    <div className={styles.panelHeader}>
                      <span>{faq.question}</span>
                      <Popconfirm
                        title="Are you sure to delete this FAQ?"
                        onConfirm={() => handleDelete(faq._id)}
                        okText="Yes"
                        cancelText="No"
                      >
                        <DeleteOutlined className={styles.deleteIcon} />
                      </Popconfirm>
                    </div>
                  }
                  key={faq.id}
                  className={styles.panel}
                >
                  <p className={styles.answerText}>{faq.answer}</p>
                </Panel>
              ))}
            </Collapse>
          </div>
        )}
      </div>
    </div>
  );
};

export default FAQs;
